import MuiAvatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';

export const StyledAvatar = styled(MuiAvatar)({}) as typeof MuiAvatar;
